import * as yup from "yup";

import { useEffect, useState, useCallback } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import ReactSelect from "../../../../../components/common/ReactSelect";
import Toaster from "../../../../../components/common/Toaster";
import journalService from "../../../../../services/journalService";

const schema = yup.object();

const AccountChartFilter = ({ options, onFilter }) => {
  const [types, setTypes] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (info) => {
    const type = info.type && info.type !== undefined ? info.type.label : "";
    onFilter(type);
  };

  const handleReset = () => {
    const type = "";
    onFilter(type);
  };

  const fetchTypes = useCallback(async (mounted) => {
    try {
      const { result } = await journalService.getAccountChartTypesAsync();

      const options = result.map((item) => {
        const option = {};
        option["label"] = item.name;
        option["value"] = item.id;

        return option;
      });

      if (mounted) setTypes(options);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  }, []);

  useEffect(() => {
    let mounted = true;

    fetchTypes(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchTypes]);

  useEffect(() => {
    if (options) {
      const selected = types.filter((i) => i.label === options.type);
      setValue("type", selected);
    }
  }, [options, types, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="type-dropdown"
            name="type"
            title="Type"
            options={types}
            control={control}
            register={register("type")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default AccountChartFilter;
